import clsx from 'clsx'
import { range } from 'lodash'
import React from 'react'
import { useStepsState } from '@context/StepsContext'
import useStyles from './StatusBarDesktop.styles'
import { ReactComponent as TickIcon } from 'src/images/tick2.svg'
import { getStepNameFromNumber } from './helper'
import { useTranslation } from 'react-i18next'
import { TEST_IDS } from 'src/constants/testIds'
import { useIsCityVariant } from '@hooks/useIsCityVariant'
import { useIsAllClinicsVariant } from '@hooks/useIsAllClinicsVariant'

export const StatusBarDesktop = () => {
  const classes = useStyles()
  const { step: currentStep = 0, totalSteps } = useStepsState()
  const { t } = useTranslation()
  // We have to subtract 1 because on the first step width of the progressBar must be 0, when step 1.5 it's 25% etc.
  const progressBarWidth = ((currentStep - 1) / (totalSteps - 1)) * 100
  const isCityVariant = useIsCityVariant()
  const isAllClinicsVariant = useIsAllClinicsVariant()

  return (
    <div id="statusBar" className={classes.root} data-test={TEST_IDS.statusBarDesktop}>
      <div className={classes.progressBar} />
      <div className={classes.activeProgressBar} style={{ width: `${progressBarWidth}%` }} />
      {range(1, totalSteps + 1).map((step) => {
        const isStepCompleted = step < currentStep

        return (
          <React.Fragment key={step}>
            <div key={step} className={clsx(classes.step, { [classes.activeStep]: step <= currentStep })}>
              {isStepCompleted ? (
                <div className={classes.completedStep}>
                  <TickIcon />
                </div>
              ) : (
                step
              )}
              <span className={clsx(classes.stepName, { [classes.activeStepName]: step === currentStep })}>
                {t(getStepNameFromNumber(step, isCityVariant, isAllClinicsVariant))}
              </span>
            </div>
          </React.Fragment>
        )
      })}
    </div>
  )
}
